import {flatten, uniq} from 'lowscore'

const restOfTheWorld = 'zz'

export const regions = {
  us: {
    name: 'United States',
    sellingCompanyCodes: [
      'AAUSAS',
      'BVUSAS',
      'CHUSAS',
      'GEUSAS',
      'IVUSAS',
      'LGUSAS',
      'TTUSAS',
      'CSUSAS',
    ],
    currency: 'USD',
  },
  uk: {
    name: 'United Kingdom',
    sellingCompanyCodes: [
      'AAUKLS',
      'AABAUS',
      'AABEUS',
      'CHUKLS',
      'IVUKLS',
      'LGUKLS',
      'TTUKLS',
      'CSUKLS',
    ],
    currency: 'GBP',
  },
  eu: {
    name: 'Europe',
    sellingCompanyCodes: [
      'AAEUOS',
      'AAMUCS',
      'CHOSTS',
      'CHEUOS',
      'IVEUOS',
      'LGEUOS',
      'TTEUOS',
      'CSEUOS',
    ],
    currency: 'EUR',
  },
  ca: {
    name: 'Canada',
    sellingCompanyCodes: [
      'AACANS',
      'BVCANS',
      'CHCANS',
      'IVCANS',
      'LGCANS',
      'TTCANS',
      'CSCANS',
    ],
    currency: 'CAD',
  },
  au: {
    name: 'Australia',
    sellingCompanyCodes: [
      'AASYDS',
      'CHSYDS',
      'IVSYDS',
      'LGSYDS',
      'TTSYDS',
      'CSSYDS',
    ],
    currency: 'AUD',
  },
  nz: {
    name: 'New Zealand',
    sellingCompanyCodes: [
      'AAAKLS',
      'CHAKLS',
      'IVAKLS',
      'LGAKLS',
      'TTAKLS',
      'CSAKLS',
    ],
    currency: 'NZD',
  },
  sg: {
    name: 'Singapore',
    sellingCompanyCodes: [
      'CHSINS',
      'IVSINS',
      'LGSINS',
      'TTSINS',
      'CSSINS',
    ],
    currency: 'USD',
  },
  za: {
    name: 'South Africa',
    sellingCompanyCodes: [
      'CHJBGS',
      'IVJBGS',
      'LGJBGS',
      'TTJBGS',
      'CSJBGS',
    ],
    currency: 'ZAR',
  },
  [restOfTheWorld]: {
    name: 'Rest of the World',
    sellingCompanyCodes: [
      'IVGSAS',
      'LGGSAS',
      'TTGSAS',
      'CSGSAS',
    ],
    currency: 'USD',
  },
}

Object.entries(regions).forEach(([regionCode, regionDetails]) => regionDetails.code = regionCode)

function brandCode (sellingCompanyCode) {
  return sellingCompanyCode.substring(0, 2)
}

function calcRegionCodesByBrandCode () {
  const regionCodesByBrandCode = flatten(Object.values(regions).map(region => {
    const brandCodesForRegion = uniq(region.sellingCompanyCodes.map(scCode => brandCode(scCode)))
    return brandCodesForRegion.map(brandCode => {
      return {brandCode, regionCode: region.code}
    })
  })).reduce((acc, brandRegion) => {
    if (!acc[brandRegion.brandCode]) {
      acc[brandRegion.brandCode] = []
    }
    acc[brandRegion.brandCode].push(brandRegion.regionCode)
    return acc
  }, {})
  return regionCodesByBrandCode
}
const regionCodesByBrandCode = calcRegionCodesByBrandCode()


export function sellingRegionsForBrand (brandCode) {
  return regionCodesByBrandCode[brandCode]
}

export function sellingRegion (sellingCompanyCode) {
  const [regionCode] = Object.entries(regions).find(([, {sellingCompanyCodes}]) => {
    return sellingCompanyCodes.find(c => c == sellingCompanyCode)
  }) || []
  return regionCode
}
export function currencyForSellingCompanyCode (sellingCompanyCode) {
  const region = sellingRegion(sellingCompanyCode)
  if (region && regions[region]) {
    return regions[region].currency
  }
}

export function brand (sellingCompanyCode) {
  return sellingCompanyCode && brandCode(sellingCompanyCode)
}

export function sellingCompanyCode (brandCode, sellingRegion) {
  return regions[sellingRegion] && regions[sellingRegion.toLowerCase()].sellingCompanyCodes.find(scCode => {
    return brand(scCode) == brandCode.toUpperCase()
  })
}

export function regionCode (regionName) {
  const region = Object.values(regions).find(region => region.name === regionName)

  if (!region) {
    throw new Error('could not find region: ' + regionName)
  }

  return region
}

export const sellingCompanyCodes = flatten(Object.values(regions).map(r => r.sellingCompanyCodes))
